<script setup lang="ts">
import {onMounted} from 'vue';
import {useHead} from '@vueuse/head';
import {useLiveChat, chatSupportImage} from '@teemill/modules/live-chat';
import QuoteForm from './partials/QuoteForm.vue';

useHead({title: 'Get a quote'});

onMounted(() => {
  const {updateGroup, notify} = useLiveChat();

  updateGroup('support');

  setTimeout(() => {
    notify({
      title: 'Live Support',
      body: 'A member of our team is online and available to assist.',
      image: chatSupportImage,
      buttonStyle: 'default',
      buttonText: 'Start Chatting',
    });
  }, 6000);
});
</script>

<template>
  <div class="pt-8 bg-[--tml-page-background-color] text-[--tml-text-color]">
    <h1>Get a screenprint price</h1>
    <p class="pb-6">
      We've taken the hassle out of t-shirt printing pricing with this handy
      calculator. Get your quote in 30 seconds
    </p>
    <QuoteForm />
  </div>
</template>